/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'advanced-search.labels.filter.no.text': 'Start typing to search for a label',
  'ai-summary-label': 'Summarize',
  'archive.label': 'Archive',
  'assets-app-message-banner-available-soon':
    '<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
  'assets-app-message-banner-dismiss-message': 'Dismiss',
  'assets-search-available-soon-message-banner':
    '<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
  attachment_type: 'Attachment',
  'audio.label': 'Audio',
  avatar: 'Avatar',
  'blogpost.label': 'Blogpost',
  blogpost_type: 'Blogpost',
  'bulk-connect-cancel': 'Cancel',
  'bulk-connect-dialog-subheading': 'Find missing results by connecting the apps you use in your work',
  'bulk-connect-dialog-title': 'Connect your apps',
  'bulk-connect-done': 'Done',
  'bulk-connect-no-results': "We couldn't find apps matching your search",
  'calendar-event-search-result.calendar-label': 'Calendar',
  'calendar-event-search-result.created.placeholder': '{person} created',
  'calendar-event-search-result.external-person': 'External person',
  'calendar-event-search-result.join-meeting-link': 'Join meeting',
  'calendar-event-search-result.meeting-link': 'Meeting link',
  'calendar-event-search-result.meeting-link-icon': 'Join meeting',
  'calendar-event-search-result.past-events-button': 'Past events',
  'calendar-event-search-result.recurring-event-icon': 'Recurring event',
  'calendar-event-search-result.recurring-event-label': 'Recurring',
  'calendar-event-search-result.upcoming-events-button': 'Upcoming events',
  'channel.label': 'Channel',
  'code.label': 'Code',
  'comment-result.label': 'Comment',
  comment_type: 'Comment',
  'confluence-data-center-search-result.document.attachmentLabel': 'Attachment',
  'confluence-data-center-search-result.document.blogpostLabel': 'Blog Post',
  'confluence-data-center-search-result.document.commentLabel': 'Comment',
  'confluence-data-center-search-result.document.pageLabel': 'Page',
  'confluence-data-center-search-result.document.spaceLabel': 'Space',
  connect_third_party_product_description: 'Connect your account to see missing results',
  connect_third_party_product_title: 'Your admin has added {product}!',
  connect_third_party_product_title_alternate: '{product} is now available!',
  'copied-link-tooltip-label': 'Copied!',
  'copy-content-link-label': 'Copy link',
  'copy-link-button-label': 'Copy Link Button',
  'copy-link-link-icon-label': 'Link icon',
  'copy-link-success-icon-label': 'Success icon',
  'copy-link-tooltip-label': 'Copy link',
  'customer-org-search-result.customer-org-label': 'Customer Organization',
  'customer-org.label': 'Customer Org',
  'dashboard.label': 'Dashboard',
  'database.label': 'Database',
  'date.filter.after.label': 'after',
  'date.filter.any.time': 'Anytime',
  'date.filter.before.label': 'before',
  'date.filter.custom': 'Custom',
  'date.filter.custom.invalid.after.end': 'The From date has to be before the To date',
  'date.filter.custom.invalid.after.today': 'The From date can’t be in the future',
  'date.filter.custom.invalid.to.after.today': 'The To date can’t be in the future',
  'date.filter.from.title': 'From',
  'date.filter.input.placeholder': 'Choose a date',
  'date.filter.last.month': 'Past 30 days',
  'date.filter.last.week': 'Past 7 days',
  'date.filter.last.year': 'Past year',
  'date.filter.title': 'Last updated',
  'date.filter.to.range': 'to',
  'date.filter.to.title': 'To',
  'date.filter.today': 'Today',
  'date.filter.update.button': 'Update',
  'date.filter.yesterday': 'Yesterday',
  'deal-search-result.closed-on': 'Closed on {date}',
  'deal-search-result.deal-label': 'Deal',
  'deal.label': 'Deal',
  'design-search-result.label': 'Design',
  'design.label': 'Design',
  'document-search-result.google-docs-label': 'Docs',
  'document-search-result.google-sheets-label': 'Sheets',
  'document-search-result.google-slides-label': 'Slides',
  'document-search-result.ms-excel-label': 'Excel',
  'document-search-result.ms-powerpoint-label': 'PowerPoint',
  'document-search-result.ms-word-label': 'Word',
  'document.label': 'Document',
  dropdown_generate_answer: 'Generate answer',
  dropdown_recent_icon_label: 'Recent',
  dropdown_search: 'Search',
  dropdown_search_icon_label: 'Search',
  'email-search-result.email.label': 'Email',
  'email-search-result.external-person.label': 'External person',
  'email-search-result.forwarded.label': '{person} forwarded',
  'email-search-result.inbox.label': 'Inbox',
  'email-search-result.sent.label': '{person} sent',
  'email-search-result.timestamp.label': '{formattedDate}',
  'error-boundary.code': 'The code associated with this error: {code}',
  'error-boundary.description':
    'The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:',
  'error-boundary.description.support-link': 'Atlassian Support',
  'error-boundary.reload-page': 'Refresh page',
  'error-boundary.support-link-text': 'our support team',
  'error-boundary.title': "We've hit a snag",
  'error-boundary.url': 'The URL of this page',
  error_primary: "We're having trouble searching",
  error_secondary: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
  externalPeopleLabel: 'External people #{channelName}',
  externalPersonLabel: 'External person',
  'file.label': 'File',
  filter: 'Filter icon',
  'github-branch-result.label': 'Branch',
  'github-commit-result.label': 'Commit',
  'github-pull-request-result.label': 'Pull request',
  give_feedback_text: 'Give feedback',
  'image.label': 'Image',
  'inline-app-selector.3p-app-tooltip': 'Open a full page search for this term filtered by {productName} results',
  'inline-app-selector.all-apps-tooltip': 'Open a full page search for this term searching all apps',
  'inline-app-selector.external-link-icon.label': 'External Link Icon',
  'inline-product-filters.external-link-icon.label': 'External Link Icon',
  'inline-product-filters.more-filters.label': 'More',
  'inline-product-filters.more-filters.tooltip': 'Open a full page search with more filter options for {product}',
  input_clear_icon_label: 'Clear',
  input_copy_link_icon_label: 'Copy link',
  input_placeholder: 'Search',
  input_placeholder_default: 'Search for anything',
  input_placeholder_ghost_text_kpi_acronym: 'Search any acronym, like "KPI"',
  input_placeholder_ghost_text_mention_teammates: '@mention a teammate to see their work',
  input_placeholder_ghost_text_search_across: 'Search across {products}, and more',
  input_placeholder_ghost_text_search_teammate: 'Search the name of a teammate',
  input_placeholder_ghost_text_submit_expense: 'Ask a question like "How do I submit an expense?"',
  input_placeholder_nav3: 'Search',
  input_placeholder_with_atlassian_intelligence: 'Search or ask anything',
  input_placeholder_with_rovo: 'Search or ask Rovo',
  input_search_icon_label: 'Search',
  'invoice.label': 'Invoice',
  'issue.label': 'Issue',
  issue_type: 'Work item',
  'jira-dc.comment-result.label': 'Comment',
  'jira-dc.issue-result.label': 'Work item',
  'jira-dc.project-result.label': 'Project',
  'jira-dc.work-item-assignee.assigned':
    '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
  'jira-dc.work-item-creator.created':
    '{created, select, internal {{firstName} created} other {External person created}}',
  'jira-dc.work-item-status.for': '{statusLozenge} for {dateLozenge}',
  'jira-dc.work-item-task.issue': 'Issue',
  'jira-dc.work-item.label': 'Work item',
  jira_advanced_search: 'Search Jira for work items',
  jira_single_site_boards: 'Boards',
  jira_single_site_filters: 'Filters',
  jira_single_site_label: 'Go to all:',
  jira_single_site_people: 'Teams',
  jira_single_site_plans: 'Plans',
  jira_single_site_projects: 'Projects',
  landing_primary: 'Seek and you shall find',
  landing_secondary: "Search for what you're looking for in your Atlassian and connected apps",
  landing_secondary_rovo: "Search or ask Rovo what you're looking for in your Atlassian and connected apps",
  landing_secondary_unified_with_sain: 'Search or ask anything across your Atlassian apps',
  landing_secondary_unified_without_sain: 'Search for anything across your Atlassian apps',
  landing_secondary_with_atlassian_intelligence:
    "Search or ask what you're looking for in your Atlassian and connected apps",
  'leap-query.title.related-search': 'Related searches',
  'leap-query.title.teammates-also-ask': 'Your teammates also ask',
  'link-attachments.button.label': '{count, plural, one {# link} other {# links}}',
  live_doc_type: 'Live Doc',
  'more-actions-label': 'More Actions',
  'more-label': 'More',
  'new-product-message-banner': "{product} was only recently added and we're still tweaking the results.",
  'new-product-message-banner-dismiss-message': 'Dismiss',
  'new-product-message-banner-dismiss-message-button': 'Dismiss',
  'new-product-message-banner-text': "{product} was only recently added and we're still tweaking the results.",
  noOptions: 'No options',
  no_results_clear_filters: 'Clear filters',
  no_results_primary: "We couldn't find anything matching your search",
  no_results_secondary_no_filters: 'Try again with a different term.',
  no_results_secondary_some_filters_applied: 'Looks like you have some filters applied. You could try clearing them.',
  'oauth-banner.authorization-fail': 'Failed to connect to {product}.',
  'oauth-banner.authorization-success': 'Account connected to {product}.',
  'oauth-message-connect': 'Connect',
  'oauth-message-dismiss': 'Dismiss',
  'other.label': 'Other',
  'page.label': 'Page',
  page_type: 'Page',
  'pdf.label': 'PDF',
  'presentation.label': 'Presentation',
  'product-tile-check-icon-label': 'Check Icon',
  'product-tile-connect': 'Connect',
  'product-tile-connected': 'Connected',
  'product-tile-error-icon-label': 'Error Icon',
  'product-tile-external-link-icon-label': 'External Link Icon',
  'product-tile-failed': 'Failed.',
  'product-tile-new': 'New',
  'product-tile-oauth-warning.authorization-fail': 'Failed to connect to {product}',
  'product-tile-oauth-warning.authorization-success': 'Successfully connected to {product}',
  'product-tile-try-again': 'Try again',
  'project.label': 'Project',
  'quick-find-filters.filter-by-icon-label': 'Filter by Icon',
  'quick-find.confluence.filter.contributor.placeholder': 'Find people',
  'quick-find.confluence.filter.label.selected': 'Selected',
  'quick-find.confluence.filter.label.unselected': 'Suggested',
  'quick-find.filters.clear-filters-button-label': 'Clear filters',
  'quick-find.filters.names.assignee': 'Assignee',
  'quick-find.filters.names.contributor': 'Contributor',
  'quick-find.filters.names.project': 'Project',
  'quick-find.filters.names.project-galaxia': 'Space',
  'quick-find.jira.filter.assignee.placeholder': 'Find people',
  'quick-find.jira.filter.assignee.selected': 'Selected',
  'quick-find.jira.filter.assignee.unselected': 'Suggested',
  'quick-find.jira.filter.project.placeholder': 'Find projects',
  'quick-find.jira.filter.project.placeholder-galaxia': 'Find spaces',
  'quick-find.jira.filter.project.selected': 'Selected',
  'quick-find.jira.filter.project.unselected': 'Suggested',
  'quick-find.mercury.focus-area-status-update.title': 'Update for {focusAreaName}',
  quick_find_dialog_aria_label: 'Quick Find',
  recents_heading: 'Search Results',
  'relay.jira-dc-work-item.issue-label': 'Issue',
  'relay.jira-dc-work-item.work-item.work-item-label': 'Work item',
  'relay.jira-dc.comment-result.label': 'Comment',
  'relay.jira-dc.issue-result.label': 'Work item',
  'relay.jira-dc.project-result.label': 'Project',
  'relay.jira-dc.work-item-assignee.assigned':
    '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
  'relay.jira-dc.work-item-creator.created':
    '{created, select, internal {{firstName} created} other {External person created}}',
  'relay.jira-dc.work-item-status.for': '{statusLozenge} for {dateLozenge}',
  'relay.search-page.results.product-results.third-party.message-search-result.member-count':
    '{count, plural, one {# member} other {# members}}',
  'relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label':
    '{count, plural, one {# attachment} other {# attachments}}',
  'relay.search-result.attachment-label': 'Attachment',
  'relay.search-result.attachments.attached-date.label': 'Attached {formattedDate}',
  'relay.search-result.attachments.audio-label': 'Audio',
  'relay.search-result.attachments.expand.label': 'Expand',
  'relay.search-result.attachments.image-label': 'Image',
  'relay.search-result.attachments.pdf-label': 'PDF',
  'relay.search-result.attachments.video-label': 'Video',
  'relay.search-result.message-last-active': 'Last active {formattedDate}',
  'relay.search-result.message-type-label': 'Message',
  'relay.search-result.private-channel-label': 'Private Channel',
  'relay.search-result.thread-type-label': 'Thread',
  'repository.label': 'Repository',
  'results-sort.createdDate.selected': 'Sort by created (newest)',
  'results-sort.createdDateDESC': 'Created (newest)',
  'results-sort.latestModifiedDateASC': 'Created (oldest)',
  'results-sort.latestModifiedDateASC.selected': 'Sort by created (oldest)',
  'results-sort.latestModifiedDateDESC': 'Updated (newest)',
  'results-sort.latestModifiedDateDESC.selected': 'Sort by updated (newest)',
  'results-sort.relevanceDESC': 'Relevance',
  'results-sort.relevanceDESC.selected': 'Sort by relevance',
  'results-sort.sort-options.label': 'Change list sorting',
  'rovo-onboarding-ok': 'OK',
  'rovo-onboarding-step-1-description':
    'Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.',
  'rovo-onboarding-step-1-heading': 'Search across company apps',
  'rovo-search.confluence.filter.icon.label': 'Confluence filter',
  'rovo-search.jira.filter.icon.label': 'Jira filter',
  'seaech-page.townsquare.api.goal-state.archived': 'Archived',
  'seaech-page.townsquare.api.goal-state.at-risk': 'At risk',
  'seaech-page.townsquare.api.goal-state.cancelled': 'Canceled',
  'seaech-page.townsquare.api.goal-state.completed': 'Completed',
  'seaech-page.townsquare.api.goal-state.off-track': 'Off track',
  'seaech-page.townsquare.api.goal-state.on-track': 'On track',
  'seaech-page.townsquare.api.goal-state.paused': 'Paused',
  'seaech-page.townsquare.api.goal-state.pending': 'Pending',
  'search-branch-result.label': 'Branch',
  'search-commit-result.label': 'Commit',
  'search-federated-result.email.label': 'Email',
  'search-federated-result.external-person.label': 'External person',
  'search-federated-result.forwarded.label': '{person} forwarded',
  'search-federated-result.inbox.label': 'Inbox',
  'search-federated-result.sent.label': '{person} sent',
  'search-federated-result.timestamp.label': '{formattedDate}',
  'search-graph-calendar.calendar-label': 'Calendar',
  'search-graph-calendar.created.placeholder': '{person} created',
  'search-graph-calendar.external-person': 'External person',
  'search-graph-calendar.join-meeting-link': 'Join meeting',
  'search-graph-calendar.meeting-link': 'Meeting link',
  'search-graph-calendar.meeting-link-icon': 'Join meeting',
  'search-graph-calendar.past-events-button': 'Past events',
  'search-graph-calendar.recurring-event-icon': 'Recurring event',
  'search-graph-calendar.recurring-event-label': 'Recurring',
  'search-graph-calendar.upcoming-events-button': 'Upcoming events',
  'search-graph-confluence-dc.document.attachmentLabel': 'Attachment',
  'search-graph-confluence-dc.document.blogpostLabel': 'Blog Post',
  'search-graph-confluence-dc.document.commentLabel': 'Comment',
  'search-graph-confluence-dc.document.pageLabel': 'Page',
  'search-graph-confluence-dc.document.spaceLabel': 'Space',
  'search-graph-customer-org.customer-org-label': 'Customer Organization',
  'search-graph-deal.closed-on': 'Closed on {date}',
  'search-graph-deal.deal-label': 'Deal',
  'search-graph-default.dashboard.label': 'Dashboard',
  'search-graph-default.deal.label': 'Deal',
  'search-graph-default.design.label': 'Design',
  'search-graph-default.invoice.label': 'Invoice',
  'search-graph-default.task.label': 'Task',
  'search-graph-jira-dc.comment-result.label': 'Comment',
  'search-graph-jira-dc.issue-result.label': 'Work item',
  'search-graph-jira-dc.project-result.label': 'Project',
  'search-graph-video.dropdown-message':
    '{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
  'search-graph-video.video-icon-label': 'video icon',
  'search-graph-video.video-thumbnail-alt-text': 'Video thumbnail',
  'search-graph-work-item.approval': 'Approval',
  'search-graph-work-item.bug.label': 'Bug',
  'search-graph-work-item.epic.label': 'Epic',
  'search-graph-work-item.incident': 'Incident',
  'search-graph-work-item.issue': 'Issue',
  'search-graph-work-item.label': 'Work item',
  'search-graph-work-item.milestone.label': 'Milestone',
  'search-graph-work-item.problem': 'Problem',
  'search-graph-work-item.question': 'Question',
  'search-graph-work-item.section': 'Section',
  'search-graph-work-item.story.label': 'Story',
  'search-graph-work-item.task.label': 'Task',
  'search-icon-label': 'Search',
  'search-icon-placeholder': 'Search',
  'search-page-relay.results.product-results.third-party.conversation-search-result.label': 'Channel',
  'search-page-relay.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {# member} other {# members}}',
  'search-page-relay.results.product-results.third-party.conversation-search-result.private-channel': 'Private channel',
  'search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label':
    'Last active {formattedDate}',
  'search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel': 'unknown-channel',
  'search-page.app-filter-sidebar.all': 'All',
  'search-page.app-filter-sidebar.filter-menu.menu-item.hide': 'Hide filter',
  'search-page.app-filter-sidebar.filter-menu.trigger': 'Show more options',
  'search-page.app-filter-sidebar.group': 'Filter search by app',
  'search-page.app-filter-sidebar.improve-search': 'Improve search',
  'search-page.app-filter-sidebar.show-more.button.label': 'Show more',
  'search-page.app-filter-sidebar.show-more.filter.placeholder': 'Find apps',
  'search-page.atlas.for': 'for',
  'search-page.atlas.goal.for': 'for',
  'search-page.browser-extension-banner.close-button-label': 'Close browser extension banner',
  'search-page.browser-extension-banner.link-text': 'Get the browser extension',
  'search-page.browser-extension-banner.title': 'Use Rovo wherever you are',
  'search-page.comment-icon-label': 'Comment',
  'search-page.common.ui.clear-filter-button.label': 'Clear filter',
  'search-page.compass.owner-name': 'Owned by {ownerName}',
  'search-page.compass.state': '{state}',
  'search-page.compass.tier': 'Tier {tier}',
  'search-page.confluence.filter.content.placeholder': 'Find content',
  'search-page.confluence.filter.content.selected': 'Selected',
  'search-page.confluence.filter.content.unselected': 'Suggested',
  'search-page.confluence.filter.contributor.label.selected': 'Selected',
  'search-page.confluence.filter.contributor.label.unselected': 'Suggested',
  'search-page.confluence.filter.contributor.placeholder': 'Find people',
  'search-page.confluence.filter.creator.placeholder': 'Find people',
  'search-page.confluence.filter.creator.selected': 'Selected',
  'search-page.confluence.filter.creator.unselected': 'Suggested',
  'search-page.confluence.filter.icon.label': 'Confluence filter',
  'search-page.confluence.filter.label.selected': 'Selected',
  'search-page.confluence.filter.label.unselected': 'Suggested',
  'search-page.confluence.filter.labels.placeholder': 'Find labels',
  'search-page.confluence.filter.space.icon': 'Space Icon',
  'search-page.confluence.filter.space.placeholder': 'Find spaces',
  'search-page.dashboard.label': 'Dashboard',
  'search-page.deal.label': 'Deal',
  'search-page.design.label': 'Design',
  'search-page.filter.app-select.all': 'All',
  'search-page.filter.app-select.label.selected': 'Selected',
  'search-page.filter.app-select.label.unselected': 'Suggested',
  'search-page.filter.app-select.placeholder': 'Find app',
  'search-page.filter.clear.filter.label': 'Clear filter',
  'search-page.filter.last.updated.anytime': 'Anytime',
  'search-page.filter.last.updated.costum': 'Custom',
  'search-page.filter.last.updated.past30Days': 'Past 30 days',
  'search-page.filter.last.updated.past7Days': 'Past 7 days',
  'search-page.filter.last.updated.pastYear': 'Past year',
  'search-page.filter.last.updated.today': 'Today',
  'search-page.filter.last.updated.yesterday': 'Yesterday',
  'search-page.filter.pageStatus.all': 'All',
  'search-page.filter.pageStatus.inProgress': 'In progress',
  'search-page.filter.pageStatus.readyForReview': 'Ready for review',
  'search-page.filter.pageStatus.roughDraft': 'Rough draft',
  'search-page.filter.pageStatus.verified': 'Verified',
  'search-page.filter.status.done': 'Done',
  'search-page.filter.status.open': 'Open',
  'search-page.filter.suggested.options.section': 'Suggested',
  'search-page.filter.type.all': 'All',
  'search-page.filter.type.answer': 'Answers',
  'search-page.filter.type.attachment': 'Attachments',
  'search-page.filter.type.blogpost': 'Blog posts',
  'search-page.filter.type.board': 'Boards',
  'search-page.filter.type.branch': 'Branches',
  'search-page.filter.type.calendar': 'Calendars',
  'search-page.filter.type.card': 'Cards',
  'search-page.filter.type.comment': 'Comments',
  'search-page.filter.type.commit': 'Commits',
  'search-page.filter.type.component': 'Components',
  'search-page.filter.type.conversation': 'Conversations',
  'search-page.filter.type.customer-org': 'Customer Organizations',
  'search-page.filter.type.dashboard': 'Dashboards',
  'search-page.filter.type.data-table': 'Data Table',
  'search-page.filter.type.database': 'Databases',
  'search-page.filter.type.deal': 'Deals',
  'search-page.filter.type.design': 'Designs',
  'search-page.filter.type.documents': 'Documents',
  'search-page.filter.type.embed': 'Smart Links',
  'search-page.filter.type.filter': 'Filters',
  'search-page.filter.type.focus-area': 'Focus areas',
  'search-page.filter.type.folder': 'Folders',
  'search-page.filter.type.gliffy': 'Gliffy Diagrams',
  'search-page.filter.type.goal': 'Goals',
  'search-page.filter.type.incident': 'Incidents',
  'search-page.filter.type.invoice': 'Invoices',
  'search-page.filter.type.issue': 'Issues',
  'search-page.filter.type.jira-work-item': 'Work items',
  'search-page.filter.type.message': 'Messages',
  'search-page.filter.type.object': 'Objects',
  'search-page.filter.type.page': 'Pages',
  'search-page.filter.type.placeholder': 'Find type',
  'search-page.filter.type.plan': 'Plans',
  'search-page.filter.type.presentation': 'Presentations',
  'search-page.filter.type.project': 'Projects',
  'search-page.filter.type.pull-request': 'Pull requests',
  'search-page.filter.type.question': 'Questions',
  'search-page.filter.type.repository': 'Repositories',
  'search-page.filter.type.schema': 'Schemas',
  'search-page.filter.type.space': 'Spaces',
  'search-page.filter.type.space-calendar': 'Space calendars',
  'search-page.filter.type.spreadsheet': 'Spreadsheets',
  'search-page.filter.type.tag': 'Tags',
  'search-page.filter.type.type': 'Object types',
  'search-page.filter.type.video': 'Videos',
  'search-page.filter.type.web-page': 'Web pages',
  'search-page.filter.type.whiteboard': 'Whiteboards',
  'search-page.filter.type.work-item': 'Tasks',
  'search-page.filters.clear-filters-button-label': 'Clear filters',
  'search-page.filters.dropdown.button': 'More filters',
  'search-page.filters.dropdown.clear-filters': 'Clear filters',
  'search-page.filters.names.app-select': 'App',
  'search-page.filters.names.archived': 'Show archived content',
  'search-page.filters.names.archivedAndPendingComponents': 'Show archived/pending components',
  'search-page.filters.names.assignee': 'Assignee',
  'search-page.filters.names.content': 'Content under',
  'search-page.filters.names.contributor': 'Contributor',
  'search-page.filters.names.createdBy': 'Created by',
  'search-page.filters.names.focusAreaType': 'Focus area type',
  'search-page.filters.names.focusAreaUnder': 'Focus area under',
  'search-page.filters.names.labels': 'Label',
  'search-page.filters.names.lastUpdatedBy': 'Last Updated By',
  'search-page.filters.names.owner': 'Owner',
  'search-page.filters.names.pageStatus': 'Status',
  'search-page.filters.names.project': 'Project',
  'search-page.filters.names.reporter': 'Reporter',
  'search-page.filters.names.space': 'Space',
  'search-page.filters.names.status': 'Status',
  'search-page.filters.names.titleMatchOnly': 'Search title only',
  'search-page.filters.names.type': 'Type',
  'search-page.filters.names.verified': 'Verified',
  'search-page.filters.suggested-filters-section-label': 'Suggested',
  'search-page.invoice.label': 'Invoice',
  'search-page.jira.filter.assignee.placeholder': 'Find people',
  'search-page.jira.filter.assignee.selected': 'Selected',
  'search-page.jira.filter.assignee.unselected': 'Suggested',
  'search-page.jira.filter.project.placeholder': 'Find projects',
  'search-page.jira.filter.project.selected': 'Selected',
  'search-page.jira.filter.project.unselected': 'Suggested',
  'search-page.jira.filter.reporter.placeholder': 'Find people',
  'search-page.jira.filter.reporter.selected': 'Selected',
  'search-page.jira.filter.reporter.unselected': 'Suggested',
  'search-page.linked-results.found-in': 'Found in',
  'search-page.linked-results.related': 'Related links',
  'search-page.linked-results.similar': '{count} similar',
  'search-page.mercury.filter.content.placeholder': 'Find focus areas',
  'search-page.mercury.filter.content.selected': 'Selected',
  'search-page.mercury.filter.content.unselected': 'Suggested',
  'search-page.mercury.filter.focusAreaType.label.selected': 'Selected',
  'search-page.mercury.filter.focusAreaType.label.unselected': 'Suggested',
  'search-page.mercury.filter.focusAreaType.placeholder': 'Find focus area types',
  'search-page.mercury.focus-area-status-update.title': 'Update for {focusAreaName}',
  'search-page.mercury.focus-area-update.title': 'Update for {focusAreaName}',
  'search-page.mercury.for': 'for',
  'search-page.mercury.target-date.for': 'for',
  'search-page.nouns.goal': 'Goal',
  'search-page.nouns.goals': 'Goals',
  'search-page.nouns.project': 'Project',
  'search-page.nouns.projects': 'Projects',
  'search-page.nouns.tag': 'Tag',
  'search-page.nouns.tags': 'Tags',
  'search-page.products.custom-website': 'Web page',
  'search-page.products.custom-websites': 'Web pages',
  'search-page.profile-avatar.label': 'Person Avatar',
  'search-page.relay.compass.owner-name': 'Owned by {ownerName}',
  'search-page.relay.compass.tier': 'Tier {tier}',
  'search-page.results.private-result-label': 'Private',
  'search-page.results.private-result-tooltip': 'Only visible to you',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {# member} other {# members}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Channel',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Channel',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {# member} other {# members}}',
  'search-page.results.product-results.third-party.conversation-search-result.private-channel': 'Private channel',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Last active {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'unknown-channel',
  'search-page.results.product-results.third-party.external-people-label': 'External people',
  'search-page.results.product-results.third-party.external-person-label': 'External person',
  'search-page.results.product-results.third-party.last-active': 'Last active {relativeDate}',
  'search-page.results.product-results.third-party.message-search-result.member-count':
    '{count, plural, one {# member} other {# members}}',
  'search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip':
    'Restricted - Only specific people can see this result',
  'search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label':
    '{count, plural, one {# attachment} other {# attachments}}',
  'search-page.results.product-results.third-party.message-type-label': 'Message',
  'search-page.results.product-results.third-party.no-contributors-label': 'External people in #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} in a private conversation',
  'search-page.results.product-results.third-party.thread-type-label': 'Thread',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
  'search-page.results.restricted-result-label': 'Restricted',
  'search-page.results.restricted-result-tooltip': 'Only visible to specific people',
  'search-page.show-more-breadcrumbs-button-label': 'Show more breadcrumbs',
  'search-page.tab-filter.all-filter-visual-label': 'Filter by all apps',
  'search-page.tab-filter.more-dropdown-label': 'Filter by more apps',
  'search-page.task.label': 'Task',
  'search-page.verified-icon-label': 'Verified',
  'search-page.verified-icon-tooltip-message': 'This page has been verified by an owner or admin.',
  'search-pull-request-result.label': 'Pull request',
  'search-respository-result.label': 'Repository',
  'search-result.attachment-label': 'Attachment',
  'search-result.attachments.attached-date.label': 'Attached {formattedDate}',
  'search-result.attachments.audio-label': 'Audio',
  'search-result.attachments.expand.label': 'Expand',
  'search-result.attachments.image-label': 'Image',
  'search-result.attachments.pdf-label': 'PDF',
  'search-result.attachments.video-label': 'Video',
  'search-result.direct-message-single-user': '{name1} and 1 other',
  'search-result.direct-message-two-users': '{name1} and {name2}',
  'search-result.federated-group-direct-message':
    '{knownNamesCount, plural, =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2} and {name3}} other {{name1}, {name2} and {name3}} }',
  'search-result.federated-group-direct-message-with-others':
    '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} other} =2 {{name1}, {name2} and {totalOthersCount} other} =3 {{name1}, {name2}, {name3} and {totalOthersCount} other} other {{name1}, {name2}, {name3} and {totalOthersCount} other} }',
  'search-result.group-direct-message-unknown-names': '{totalPeopleCount} people',
  'search-result.last-modified': 'Updated {formattedDate}',
  'search-result.message-last-active': 'Last active {formattedDate}',
  'search-result.message-type-label': 'Message',
  'search-result.private-channel-label': 'Private Channel',
  'search-result.remove-recent-search': 'Remove recent search icon',
  'search-result.remove-recent-search-result-subheading': 'Recent search',
  'search-result.repository-label': 'Repository',
  'search-result.thread-title-with-others':
    '{contributorCount, plural, =0 {Group message with external users} =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other} other {{name1}, {name2}, {name3}, and {overflowContributorCount} others} }',
  'search-result.thread-type-label': 'Thread',
  'search-result.unknown-channel-in-thread': 'unknown-channel',
  'search-result.user-mention.external-person': 'External person',
  'search.bulk-connect-banner.initial.banner.connect.text': 'Connect your apps',
  'search.bulk-connect-banner.initial.banner.title': 'Your teammates connected their apps and got better results',
  'search.bulk-connect-banner.multiple.products.banner.connect.text': "Let's do this",
  'search.bulk-connect-banner.multiple.products.banner.description': 'Connect your accounts to get missing results',
  'search.bulk-connect-banner.multiple.products.banner.title':
    '{count, plural, one {Your admin approved # new app!} other {Your admin approved # new apps!}}',
  'search.bulk-connect-banner.single.product.banner.connect.text': 'Connect',
  'search.bulk-connect-banner.single.product.banner.description': 'Connect your account to get missing results',
  'search.bulk-connect-banner.single.product.banner.title': 'Your admin just added {product}!',
  search_dialog_aria_label: 'Search Dialog',
  search_dialog_assets_unavailable_message:
    '<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>.',
  search_dialog_browser_history_heading: 'Browser work history',
  search_dialog_browser_history_heading_learn_more: 'Why am I seeing this?',
  search_dialog_dismiss_banner_label: 'Dismiss banner',
  search_dialog_error_search_body:
    'It might just be a hiccup. Please try refreshing the page or <button>try again</button>.',
  search_dialog_error_search_heading: "We're having trouble loading your recently viewed content.",
  search_dialog_feedback_footer: 'Help us improve search',
  search_dialog_no_content_body: "Search for what you're looking for in your Atlassian and integrated apps",
  search_dialog_no_content_body_with_atlassian_intelligence:
    "Search or ask what you're looking for in your Atlassian and integrated apps",
  search_dialog_no_content_body_with_rovo:
    "Search or ask Rovo what you're looking for in your Atlassian and integrated apps",
  search_dialog_no_content_heading: 'Seek and you shall find',
  search_dialog_no_results_heading: "We couldn't find any results with that title",
  search_dialog_recent_search: 'Recent search',
  search_dialog_recents_heading: 'Recent',
  search_dialog_recommendations_heading: 'Recommendations',
  search_dialog_remove_recent_search_label: 'Remove recent search',
  search_dialog_rovo_banner_message:
    'Enter a question like “What’s the vacation policy?” and Rovo will find the answer',
  search_dialog_rovo_tip: 'Rovo tip:',
  search_dialog_search_across_products: 'Search all apps',
  'search_dialog_search_across_products.more': 'more',
  search_dialog_team: 'Team',
  search_dialog_zero_query: 'Suggested',
  search_dialog_zero_query_icon_label: 'Suggested search',
  search_result_type_answer: 'Answer',
  search_result_type_attachment: 'Attachment',
  search_result_type_blogpost: 'Blog Post',
  search_result_type_board: 'Board',
  search_result_type_branch: 'Branch',
  search_result_type_calendar: 'Calendar',
  search_result_type_card: 'Card',
  search_result_type_channel: 'Channel',
  search_result_type_comment: 'Comment',
  search_result_type_commit: 'Commit',
  search_result_type_component: 'Component',
  search_result_type_customer_org: 'Customer Organization',
  search_result_type_dashboard: 'Dashboard',
  search_result_type_data_table: 'Data table',
  search_result_type_database: 'Database',
  search_result_type_deal: 'Deal',
  search_result_type_document: 'Document',
  search_result_type_email: 'Email',
  search_result_type_embed: 'Smart Link',
  search_result_type_filter: 'Filter',
  search_result_type_focus_area: 'Focus area update',
  search_result_type_folder: 'Folder',
  search_result_type_gliffy: 'Gliffy Diagram',
  search_result_type_goal: 'Goal',
  search_result_type_incident: 'Incident',
  search_result_type_issue: 'Work item',
  search_result_type_learning: 'Learning',
  search_result_type_message: 'Message',
  search_result_type_object: 'Object',
  search_result_type_page: 'Page',
  search_result_type_plan: 'Plan',
  search_result_type_presentation: 'Presentation',
  search_result_type_project: 'Project',
  search_result_type_pull_request: 'Pull Request',
  search_result_type_question: 'Question',
  search_result_type_repository: 'Repository',
  search_result_type_schema: 'Schema',
  search_result_type_sharepoint_document: 'Sharepoint Document',
  search_result_type_space: 'Space',
  search_result_type_space_calendar: 'Space calendar',
  search_result_type_spreadsheet: 'Spreadsheet',
  search_result_type_tag: 'Tag',
  search_result_type_type: 'Type',
  search_result_type_unrecognised: 'Unrecognised',
  search_result_type_whiteboard: 'Whiteboard',
  search_result_type_work_item: 'Work Item',
  'sidebar-authorize_connect_third_party_product':
    'Your admin has added <strong>{product}!</strong>{br} Connect your account to see missing results, including documents only you have access to.',
  'sidebar-authorize_connect_third_party_product_alternate_msg':
    '<strong>{product} is now available!</strong>{br} Connect your account to see missing results, including content only you have access to.',
  'sidebar-oauth-warning-authorize': 'Authorize',
  'sidebar-oauth-warning-dismiss': 'Dismiss',
  'sidebar-oauth-warning.authorization-fail': 'Failed to connect to {product}.',
  'sidebar-oauth-warning.authorization-success': 'Successfully connected to {product}.',
  'sidebar-oauth-warning.connect': 'Connect',
  'sidebar-oauth-warning.not-now': 'Not now',
  'space.label': 'Space',
  'spreadsheet.label': 'Spreadsheet',
  suggestion: 'See all results for "{inputQuery}" across apps',
  'task.label': 'Task',
  team: 'Team',
  toggle_feedback_description:
    'Are you sure you want to switch back to the previous search? Our new search gives you more ways to find results <bold>across your Atlassian apps</bold> within Confluence.',
  toggle_feedback_placeholder_title: 'Let us know why you want to switch:',
  toggle_feedback_submit_button_label: 'Switch to original',
  toggle_feedback_text_area_placeholder: "Add 'No reason' if you'd prefer to not give a reason.",
  toggle_feedback_title: 'Switch to original search',
  'townsquare.api.goal-state.archived': 'Archived',
  'townsquare.api.goal-state.at-risk': 'At risk',
  'townsquare.api.goal-state.cancelled': 'Canceled',
  'townsquare.api.goal-state.completed': 'Completed',
  'townsquare.api.goal-state.off-track': 'Off track',
  'townsquare.api.goal-state.on-track': 'On track',
  'townsquare.api.goal-state.paused': 'Paused',
  'townsquare.api.goal-state.pending': 'Pending',
  unified_search_opt_back_in_flag_fps_title: 'You’ve switched back to the new search.',
  unified_search_opt_in_flag_action_find_out_more: 'Find out more',
  unified_search_opt_in_flag_fps_action_switch_back: 'Switch back',
  unified_search_opt_in_flag_fps_description:
    'This new search allows you to find results from across all your Atlassian apps.',
  unified_search_opt_in_flag_fps_title: 'Search has changed',
  'video-search-result.dropdown-message':
    '{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
  'video-search-result.video-icon-label': 'video icon',
  'video-search-result.video-thumbnail-alt-text': 'Video thumbnail',
  'video.label': 'Video',
  'web-page.label': 'Web Page',
  whiteboard_type: 'Whiteboard',
  'work-item-assignee.assigned':
    '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
  'work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
  'work-item-status.for': '{statusLozenge} for {dateLozenge}',
  'work-item-task.approval': 'Approval',
  'work-item-task.bug': 'Bug',
  'work-item-task.epic': 'Epic',
  'work-item-task.incident': 'Incident',
  'work-item-task.issue': 'Issue',
  'work-item-task.label': 'Task',
  'work-item-task.milestone': 'Milestone',
  'work-item-task.problem': 'Problem',
  'work-item-task.question': 'Question',
  'work-item-task.section': 'Section',
  'work-item-task.story': 'Story',
  'work-item.label': 'Work item',
  work_item: 'Work item',
  your_recent_results_heading: 'Your recent results',
};
